/** Colors of the floors in the scene and the list, far from the usual colors of the scans */
const FLOOR_COLORS = [
  "#00b4d8",
  "#f72585",
  "#ffb703",
  "#80ed99",
  "#9d4edd",
  "#fb5607",
];

/**
 * @param index Index of a floor, from the lowest
 * @returns the color of the floor
 */
export function floorColor(index: number): string {
  return FLOOR_COLORS[index % FLOOR_COLORS.length];
}
